<template>
  <div @click="onClick">
       
       <div class="inline field">
        <label>Guid: </label>
        <span>{{rowData.guid}}</span>
      </div>
      <div class="inline field">
        <label>Community ID: </label>
        <span>{{rowData.community_id}}</span>
      </div>
      <div class="inline field">
        <label>Buyer Name : </label>
        <span>{{rowData.buyer_name}}</span>
      </div>
       <div class="inline field">
        <label>Vendor Name: </label>
        <span>{{rowData.vendor_name}}</span>
      </div>
       <div class="inline field">
        <label>Date Received: </label>
        <span>{{rowData.date_received}}</span>
      </div>
       <br />
       <div class="inline field">
        <label>Error Description: </label>
        <span>{{rowData.error}}</span>
      </div>
       <div class="inline field">
        <label>Resolution: </label>
        <span>{{rowData.resolution}}</span>
      </div>
       <div class="inline field">
        <label>Notes: </label>
        <span>{{rowData.notes}}</span>
      </div>
     
      
     
</div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onClick (event) {
            console.log('TrackingDetails: on-click', event.target)
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/components/integration-tracking/TrackingDetails.vue